import builder from '../builder';
import ArrowDown1 from '../../streamline-icons/light/arrow-down-1.svg';

export default builder('IconArrowDown1Light', ArrowDown1);
